const ACTIONS = {
    INQUIRY_SUBMIT: 'INQUIRY/SUBMIT',
    INQUIRY_SUCCESS: 'INQUIRY/SUCCESS',
    INQUIRY_ERROR: 'INQUIRY/ERROR',
    REQUEST_TO_BOOK: 'INQUIRY_MODAL/REQUEST_TO_BOOK',
    INQUIRY_POSTING: 'INQUIRY/POSTING'
};

const ACTION_CREATORS = {
    inquirySubmit(inquiryState) {
        return {
            type: ACTIONS.INQUIRY_SUBMIT,
            payload: {
                inquiryState
            }
        };
    },
    inquirySuccess(inquiryId) {
        return {
            type: ACTIONS.INQUIRY_SUCCESS,
            payload: {
                inquiryId
            }
        };
    },
    inquiryError(inquiryServiceErrors) {
        return {
            type: ACTIONS.INQUIRY_ERROR,
            payload: {
                inquiryServiceErrors
            }
        };
    },
    inquiryModalRequestToBook() {
        return {
            type: ACTIONS.REQUEST_TO_BOOK,
            payload: {}
        };
    },
    inquiryPosting() {
        return {
            type: ACTIONS.INQUIRY_POSTING,
            payload: {}
        }
    }
};

export default {...ACTIONS, ...ACTION_CREATORS};
